import { checkStatus } from 'helper/utils';
import { getAuthHeader } from 'helper/authHeader';
import APIURLPATH from 'constants/apiconstants';

export const logUIError = async (
	request,
	component,
	errorEvent,
	errorDescription,
	errorResponse
) => {
	try {
		request['requestBody'] = {
			component,
			errorEvent,
			errorDescription,
			errorResponse
		};
		const { headers = {} } = getAuthHeader(request);
		const response = await fetch(APIURLPATH.LOGGING_ERRORS, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...headers
			},
			body: JSON.stringify(request.requestBody)
		});

		const statusCode = response?.status;
		checkStatus(statusCode);

		if (statusCode >= 400) {
			console.error('Failed to log UI error:', statusCode);
			return false;
		} else {
			return true;
		}
	} catch (error) {
		console.error('Error while logging UI error:', error);
		return false;
	}
};
